import { configuration } from 'MoshtixShared/helper-responsive-configuration';
import { pixelsToRem } from 'MoshtixShared/helper-pixels-to-rem';
import { theme } from 'MoshtixShared/helper-theme-ticket-distro';

const minMediumQuery = configuration.getMediaQuery('medium');

// moshtix-dialog-scroll-container
export const dialogStyles = {
  backgroundColor: 'white',
  padding: pixelsToRem(16),
  maxWidth: '100%',
  borderRadius: pixelsToRem(4),
  display: 'flex',
  flexWrap: 'wrap',
  gap: pixelsToRem(12),
  marginTop: '50vh',

  p: {
    textAlign: 'left',
  },

  [minMediumQuery]: {
    marginTop: 'unset',
    width: pixelsToRem(521),
  },
};

export const buttonsWrapperCss = {
  display: 'flex',
  justifyContent: 'right',
  width: '100%',
  '>button:first-of-type': {
    marginRight: pixelsToRem(20),
  },
};

export const noteCss = {
  backgroundColor: theme.palette.lightError,
  border: `solid ${pixelsToRem(2)} ${theme.palette.error}`,
  borderRadius: pixelsToRem(8),
  width: '100%',
  display: 'flex',
  padding: pixelsToRem(10),
  gap: pixelsToRem(10),
  marginBottom: '0.75rem',
  'p:first-of-type': {
    fontWeight: '600',
  },
};

export const noteCssIcon = {
  height: pixelsToRem(33),
  width: pixelsToRem(33),
  fill: theme.palette.error,
  color: theme.palette.error,
};
